export default __webpack_public_path__ + "static/media/01.cd021fbb.jpg";